import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import "./Hero.css";

import HERO_BG from "../ui/bg_image.svg";


export const Hero = () => {

    return (
        <section
            data-testid="hero-section"
            className="hero-section position-relative w-100 overflow-hidden"
        >
            <div
                className="hero-bg-image"
                style={{ backgroundImage: `url(${HERO_BG})` }}
                aria-hidden
            />
            <div
                className="hero-overlay"
                aria-hidden
            />
            <div className="grain position-absolute top-0 bottom-0 start-0 end-0 pe-none" aria-hidden />


            <div className="position-relative container-db w-100">
                <div className="d-flex flex-column">
                    <div className="hero-content-wrapper">
                        <div
                            className="font-mono-tech hero-eyebrow fade-in-up fs-5"
                            data-testid="hero-eyebrow"
                        >
                            ⟶ Techno Creative Company
                        </div>
                        <h1
                            className="font-heading hero-title mb-3"
                            data-testid="hero-title"
                        >
                            Future
                            <br></br>
                            <p className="text-primary-custom">Made Real</p>
                        </h1>
                    </div>

                    <div className="hero-subtitle-wrapper d-flex flex-column">
                        <p
                            className="hero-subtitle mb-0"
                            data-testid="hero-subtitle"
                        >
                            High-end immersive experiences and defence-grade simulations, engineered with innovation, precision, and purpose.

                        </p>

                        <div className="d-flex flex-column flex-sm-row gap-3 pt-4">
                            <Link
                                to="/about"
                                data-testid="hero-primary-cta"
                                className="hero-btn-primary font-mono-tech text-decoration-none text-dark" style={{ fontWeight: 'bold' }}
                            >
                                Our Story
                                {/* <ArrowUpRight size={16} strokeWidth={2.5} /> */}
                            </Link>
                            <Link
                                to="/defence"
                                data-testid="hero-secondary-cta"
                                className="hero-btn-secondary font-mono-tech text-decoration-none"
                            >
                                Defence Solutions <ArrowDownRight size={16} strokeWidth={2.5} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};


export default Hero;